import { search } from '@debbie/common/dist/util/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useUsers } from '@debbie/cortex/dist/users/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import SearchInput from '../SearchInput.js';
import { UserState } from '@debbie/common/dist/users/index.js';
const UserSearch = (props) => {
    const lang = useSelector((s) => {
        return s.lang;
    });
    const usersLoader = useUsers();
    const users = h.hasData(usersLoader)
        ? usersLoader.data.filter((user) => user.state === UserState.ACTIVE &&
            (props.filter ? props.filter(user) : true))
        : [];
    const user = users.find((u) => u.id === props.selected);
    return (React.createElement("div", null,
        React.createElement(SearchInput, { loading: props.loading, placeholder: lang.users.selectUser, searchAll: (q) => {
                const res = search(users, (u) => `${u.firstName} ${u.lastName} ${u.email}`, q, {
                    returnMeta: false,
                });
                return res.map((u) => {
                    return {
                        key: u.id,
                        heading: `${u.firstName} ${u.lastName}`,
                        returnData: u,
                    };
                });
            }, searchDelay: 0, forceOpen: true, static: user ? `${user.firstName} ${user.lastName}` : null, onRemoveStatic: () => {
                props.onSelect(null);
            }, onSelect: (val) => {
                props.onSelect(val.id);
            } })));
};
export default UserSearch;
//# sourceMappingURL=UserSearch.js.map